import LiConnectionRequestIcon from '@/assets/icons/colored/ConnectionRequest';
import LiInMailIcon from '@/assets/icons/colored/Linkedin';
import { Mail } from '@/assets/icons/bold';

export const conversationConstants = {
  email: {
    id: 'email',
    value: 'email',
    bg: '#FFEBE7',
    icon: Mail,
  },
  li_inmail: {
    id: 'li_inmail',
    value: 'linkedin inmail',
    bg: '#EAF2FF',
    icon: LiInMailIcon,
  },
  li_connection: {
    id: 'li_connection',
    value: 'linkedin connection request',
    bg: '#FEE8C5',
    icon: LiConnectionRequestIcon,
  },
};
